/* eslint-disable nimbus/prefer-until-destroyed */
import { Injectable } from '@angular/core';
import { filter, map, pairwise, startWith, switchMap, take, tap } from 'rxjs/operators';
import { EnvironmentConfigurationService } from '@nimbus-library/features/configuration';
import { SettingsService } from './settings.service';
import { AssistantTasksService } from './assistant-tasks.service';
import { LoggingService } from './logging.service';
import { LocalStorageService, localStorageKeys } from './local-storage.service';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  public constructor(
    private readonly settingsService: SettingsService,
    // private readonly userSessionService: UserSessionService,
    private readonly tasksService: AssistantTasksService,
    private readonly loggingService: LoggingService,
    private readonly environmentService: EnvironmentConfigurationService,
    private readonly localStorageService: LocalStorageService,
  ) {
    this.initialize();
  }

  private initialize(): void {
    // const notInSession$ = this.userSessionService.userSession$.pipe(
    const notInSession$ = this.tasksService.connectedTask$.pipe(
      filter((x) => !x),
      take(1),
    );

    const lastReceived = this.localStorageService.getData(localStorageKeys.version);
    const envConfVersion = this.environmentService.configurationSettings.releaseVersion;

    this.settingsService.settings$
      .pipe(
        map((settings) => settings?.environment?.version),
        filter((x) => x && x !== envConfVersion),
        startWith(lastReceived ?? envConfVersion),
        pairwise(),
        filter(([currentVersion, newVersion]) => currentVersion !== newVersion),
        tap(([currentVersion, newVersion]) => {
          this.loggingService.Info(
            `Current version: ${currentVersion}
            Version ${newVersion} available.
            Application will be reloaded.`,
          );
          this.localStorageService.saveData(localStorageKeys.version, newVersion);
        }),
        switchMap(() => notInSession$),
      )
      .subscribe(() => {
        window.history.pushState({}, null, '');
        window.location.reload();
      });
  }
}
